(function () {
    "use strict";

    // @ngInject
    function CompanyAIPreferencesControllerCtor($scope, $injector) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CompanyAIPreferencesController';
    }

    Controllers.CompanyAIPreferencesController = Class(Controllers.BaseController, {
        constructor: CompanyAIPreferencesControllerCtor,
    });
}());